var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1013.64 781.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f37321;stroke:#231f20;stroke-miterlimit:10;stroke-width:32px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M884.56,356.25l-368,368a41.38,41.38,0,0,1-58.52,0h0a41.37,41.37,0,0,1,0-58.51L696.65,427.12h0a119.85,119.85,0,0,0,0-169.52L683.3,244.24l-58.52-58.52-13.36-13.35a119.85,119.85,0,0,0-169.52,0h0L41.32,572.94a68.79,68.79,0,0,0,0,97.26l.87.86a68.76,68.76,0,0,0,97.25,0L510.76,299.75a41.38,41.38,0,0,1,58.52,0h0a41.39,41.39,0,0,1,0,58.51L330.66,596.88h0a119.87,119.87,0,0,0,0,169.52L344,779.76l58.51,58.52,13.36,13.35a119.87,119.87,0,0,0,169.53,0h0L982.68,454.37a68.77,68.77,0,0,0,0-97.25l-.87-.87A68.77,68.77,0,0,0,884.56,356.25Z",
    transform: "translate(-5.18 -121.26)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.017e229ae23d545d783738fb595c777f.svg";
export { ForwardRef as ReactComponent };